<template>
  <div class="index" id="index">
    <div
      class="follow acea-row row-between-wrapper"
      v-if="followHid && isWeixin && isLogin"
    >
      <div>点击“立即关注” 即可关注公众号</div>
      <div class="acea-row row-middle">
        <div class="bnt" @click="followTap">立即关注</div>
        <span class="iconfont icon-guanbi" @click="closeFollow"></span>
      </div>
    </div>
    <div class="followCode" v-if="followCode">
      <div class="pictrue"><img :src="followUrl" /></div>
      <div class="mask" @click="closeFollowCode"></div>
    </div>

    <div class="noactivebg index_top">
      <div @click="search" class="search">
        <span class="iconfont icon-sousuo sousuo"></span
        >{{ discount_end_time.index_search_field }}
      </div>
      <ul class="menuslist">
        <li
          v-for="(item, key) in menus"
          :key="key"
          @click="menusclick(item.wap_url)"
        >
          <dl>
            <dt>
              <img
                :src="
                  menus_name == 'activity_pic' ? item.activity_pic : item.pic
                "
                alt=""
              />
            </dt>
            <dd>{{ item.name }}</dd>
          </dl>
        </li>
      </ul>
    </div>
    <!-- 弹框 -->
    <div id="mask" v-show="is_mask && is_new_goods_bananr == 1">
      <img
        class="mask_img"
        :src="new_goods_bananr"
        @click="$router.push(new_goods_bananr_url)"
      />
      <img
        class="mask_close"
        src="@assets/images/index_close.png"
        @click="is_maskOnClick"
      />
    </div>

    <!-- 轮播 -->
    <div class="slider-banner banner">
      <!-- <img
        class="ad-img"
        v-if="adImg"
        @click="$router.push(adUrl)"
        :src="adImg"
      /> -->
      <!-- <img
        :src="activity_banner[0]"
        @click="productClick(banner_jump_url[0])"
      /> -->

      <swiper :options="swiperOption" v-if="activity_banner.length">
        <swiper-slide v-for="(item, index) in activity_banner" :key="index">
          <img :src="item" @click="productClick(item.wap_url)" />
        </swiper-slide>
        <div class="swiper-pagination paginationBanner" slot="pagination"></div>
      </swiper>
    </div>
    <div class="box">
      <div class="zhuanti" v-for="(temp, index) in productList1" :key="index">
        <div
          :class="
            productListUrl[index].complete == true ? 'zhuantiT' : 'zhuantiImg2'
          "
        >
          <img
            :src="temp"
            alt=""
            @click="productClick(productListUrl[index].url)"
          />
        </div>
      </div>
      <!-- <div class="index_footer"><img :src="index_footer_img" /></div> -->
      <div class="index_footer">
      <img src="../../assets/images/home_bg.png" />
      <div class="footer_baozhang">
        <a href="javascript:;" class="img_zpbz">
          <img src="../../assets/images/home_zpbz.png" alt="" />
          <span>正品保障·权威出版</span>
        </a>
        <a href="javascript:;" class="img_zpbz">
          <img src="../../assets/images/home_zizhi.png" alt="" />
          <span>信誉资质</span>
        </a>
      </div>
      <div class="footer_banquan">
        <p>北京边走边学传媒科技有限公司 &nbsp; 版权所有</p>
        <p>全国统一销售热线：400-061-9080 &nbsp; 销售服务时间：每天9:00-21:00</p>
        <p>全国统一客服热线：400-678-6665 &nbsp; 客服服务时间：每天8:00-22:00</p>
      </div>
      <a href="javascript:;" class="footer_xuke">
        <!-- <img src="../../assets/images/footer_zheng.png" class="footer_zheng"
      /> -->
      <p>出版物经营许可证：新出发（京）零字第海260138号</p>
      <p>营业执照：91110108MAEKEJPC62</p>
    </a>
    </div>
      <hover-btn :kefu_display_status="kefu_display_status"></hover-btn>
    </div>
    <!-- 地步 -->
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import { getAllPic, follow } from "@api/public";
import { heziLogin } from "@api/user";

import HoverBtn from "@components/HoverBtn";
import { mapGetters } from "vuex";
import cookie from "@utils/store/cookie";
import dayjs from "dayjs";
const HEZI_KEY = "hezi_tel";

export default {
  name: "IndexActivityNewest",
  components: {
    swiper,
    swiperSlide,
    HoverBtn,
  },
  computed: mapGetters(["isLogin"]),
  data() {
    let that = this;
    return {
      Bulletframe: {},
      is_mask: true,
      isWeixin: this.$wechat.isWeixin(),
      followUrl: "",
      followHid: false,
      subscribe: false,
      followCode: false,
      kefu_display_status: 2,
      banner: [],
      activity_banner: [],
      banner_jump_url: [],
      routine_jump_url: "",
      new_goods_bananr_url: "",
      new_goods_bananr: "",
      menus: [],
      menus_name: "",
      discount_end_time: {
        display: false,
        end_time: "",
        time: "",
        discount_end_text: "",
        title_img: "",
        images: "",
        jump_url: [],
        index_search_field: "",
        new_goods_bananr: "",
      }, //倒计时
      is_coupon: "",
      is_new_goods_bananr: "",
      coupon_ids: [],
      zhuantiTop1: "",
      productList1: [],
      productListUrl: [],
      adImg: "",
      adUrl: "",
      swiperOption: {
        pagination: {
          el: ".paginationBanner",
          clickable: true,
        },
        autoplay: {
          disableOnInteraction: false, //用户操作swiper之后，是否禁止autoplay。默认为true：停止
          delay: 2000,
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true,
        on: {
          tap: function () {
            const realIndex = this.realIndex;
            that.goUrl(realIndex);
          },
        },
      },
      index_footer_img: "", //底部图片
      grayStyle: { filter: "grayscale(1)" },
    };
  },
  created() {
    // if (!cookie.has(HEZI_KEY)) {
    //   this.isHeZi();
    // }
    if (this.isLogin === false) {
      this.followHid = false;
    }
  },

  mounted() {
    if (sessionStorage.getItem("is_mask")) {
      this.is_mask = false;
    }
    this.getFollow();
    this.getAllPic();
    let winHeight = window.screen.height;
    document.getElementById("mask").style.height = winHeight + "px";
  },
  methods: {
    is_maskOnClick() {
      this.is_mask = false;
      sessionStorage.setItem("is_mask", this.is_mask);
    },
    getAllPic() {
      var that = this;
      var typeid = this.$route.params.typeid;
      // const res = await getAllPic(typeid)
      getAllPic(typeid)
        .then((res) => {
          // console.log(res);
          if (res.data.site_name && res.data.site_name != "学习严选") {
            that.$cookies.set("title", res.data.site_name);
          } else {
            that.$cookies.remove("title");
          }
          document.title = res.data.site_name || this.$route.meta.title;
          if (res.data.homepage_activity_info.display) {
            that.Bulletframe = res.data.Bulletframe;
            that.discount_end_time.display =
              res.data.homepage_activity_info.display;
            that.discount_end_time.jump_url =
              res.data.homepage_activity_info.jump_url;
            that.discount_end_time.index_search_field =
              res.data.homepage_activity_info.index_search_field;
            that.discount_end_time.new_goods_bananr =
              res.data.homepage_activity_info.new_goods_bananr;
            that.zhuantiTop1 = res.data.homepage_activity_info.title_img;
            that.productList1 = res.data.homepage_activity_info.images;
            that.productListUrl = res.data.homepage_activity_info.jump_url;
            that.is_new_goods_bananr =
              res.data.homepage_activity_info.is_new_goods_bananr;
            that.new_goods_bananr =
              res.data.homepage_activity_info.new_goods_bananr;
            that.activity_banner = res.data.homepage_activity_info.banner;
          } else {
            that.$router.replace("/");
            return false;
          }
          that.banner_jump_url =
            res.data.homepage_activity_info.banner_jump_url;
          // console.log(that.banner_jump_url);
          that.routine_jump_url =
            res.data.homepage_activity_info.routine_jump_url;
          that.new_goods_bananr_url =
            res.data.homepage_activity_info.new_goods_bananr_url;

          that.menus_name = res.data.homepage_activity_info.menus_name;
          that.banner = res.data.banner;
          that.menus = res.data.menus;
          that.index_footer_img = res.data.index_footer_img;
          that.kefu_display_status = res.data.kefu_display_status;
          that.adImg = res.data.newGoodsBananr.banner;
          that.adUrl = res.data.newGoodsBananr.url;
          // that.is_mask = true;
          // that.images = res.data.homepage_activity_info.images;
          if (that.isLogin) {
            that.subscribe = res.data.subscribe;
            if (!that.subscribe && that.followUrl) {
              setTimeout(function () {
                that.followHid = true;
              }, 200);
            } else {
              that.followHid = false;
            }
          } else {
            that.followHid = false;
          }
        })
        .catch((err) => {
          that.$dialog.error(err);
        });
    },
    // 轮播图跳转
    goUrl(index) {
      var that = this;
      let url = that.banner_jump_url[index];
      let newStr = url.indexOf("http") === 0;
      if (newStr) {
        window.location.href = url;
      } else {
        this.$router.push({
          path: url,
        });
      }
    },
    search() {
      this.$router.push("/search");
    },
    menusclick(menusUrl) {
      this.$router.push(menusUrl);
    },
    productClick(url) {
      this.$router.push(url);
    },

    closeFollow() {
      this.followHid = false;
    },
    followTap() {
      this.followCode = true;
      this.followHid = false;
    },
    closeFollowCode() {
      this.followCode = false;
      this.followHid = true;
    },
    getFollow() {
      follow()
        .then((res) => {
          this.followUrl = res.data.path;
        })
        .catch(() => {});
    },
    // 页面变灰
    myStyle() {
      let time = new Date();
      let nowTime = time.toLocaleString("en-US", { hour12: false }).split(" ");
      let mdy = nowTime[0];
      mdy = mdy.split("/");
      let day = parseInt(mdy[1]);
      if (day > 5 && day < 7) {
        return { filter: this.grayStyle.filter };
      }
    },
  },
};
</script>

<style scoped>
[v-cloak] {
  display: none;
}

.noscoll {
  /* height: 100%; */
  overflow: hidden;
}

/* 11 */
.index_top {
  width: 100%;
  /* height: 15.2rem; */
  /* position: relative; */
  overflow: hidden;
}

.activebg {
  background: url(../../assets/images/index_topbg_active.png) no-repeat;
  background-size: 100%;
}

/* 11 */
.noactivebg {
  /* background: url(../../assets/images/index_topbg_active.png) no-repeat; */
  background: url(../../assets/images/index_topbg_xin.png) no-repeat;
  background-size: 100%;
}

/* @media only screen and (min-device-width: 414px) and (max-device-width: 736px) and (-webkit-device-pixel-ratio: 3) {
    .index_top{
		height: 15.15rem;
	}
} */
.index {
  /* background-color: #f5f5f5; */
  background-color: #FF4E00;
}

.index .follow {
  z-index: 100000;
}

/* 11 */
.search {
  width: 94%;
  border-radius: 50px;
  margin: 0.2rem auto;
  margin-top: 0.9rem;
  height: 0.52rem;
  line-height: 0.52rem;
  background-color: #fff;
  /* padding: 0 5px; */
  color: #ccc;
  /* position: absolute;
	top: 0.86rem;
	left: 3%; */
  font-size: 0.26rem;
}

.router-pc .search {
  margin-top: 90px;
  height: 52px;
  line-height: 52px;
  font-size: 26px;
}

.sousuo {
  display: inline-block;
  width: 0.65rem;
  text-align: center;
  float: left;
}

.router-pc .sousuo {
  font-size: 25px;
}

.active {
  width: 94%;
  background-color: #fff;
  /* position: absolute;
	top: 1.6rem;
	left: 3%; */
  border-radius: 5px;
  margin: 0.2rem auto;
  overflow: hidden;
}

.active img {
  display: block;
}

.active_01 {
  width: 100%;
}

.active_02 {
  width: 100%;
}

.active_03 {
  width: 100%;
}

.activebox2 {
  width: 94%;
  background-color: #fff;
  /* position: absolute;
	top: 7.5rem;
	left: 3%; */
  border-radius: 5px;
  margin: 0.2rem auto;
}

.imgbox {
  position: relative;
}

.activebox2 img {
  display: block;
  border-radius: 5px;
}

.countdown {
  padding-left: 0.35rem;
}

.countdown span {
  color: #ff2210;
  font-size: 0.24rem;
}

.countdown i {
  display: inline-block;
  width: 0.37rem;
  /* height: 0.3rem; */
  /* line-height: 0.3rem; */
  text-align: center;
  color: #fff;
  font-size: 0.26rem;
  background-color: #ff2210;
  border-radius: 2px;
  margin: 0 0.03rem;
}

.end {
  display: inline-block;
  background-color: #ffe8e5;
  border-radius: 5px;
  padding: 0.02rem 0.1rem;
  margin-bottom: 0.2rem;
  margin-right: 0.1rem;
}

.imgbox {
  width: 100%;
}

.imgbox1 {
  position: relative;
  width: 40.56%;
  float: left;
}

.imgbox2 {
  position: relative;
  width: 59.44%;
  float: left;
}

.shopcar {
  width: 0.5rem;
  position: absolute;
  bottom: 0.3rem;
  right: 0.3rem;
}

.menuslist {
  width: 94%;
  /* height: 150px; */
  background-color: #fff;
  padding: 0 0.2rem 0.3rem 0.2rem;
  margin: 0.2rem auto;
  margin-bottom: 0;
  border-radius: 5px;
  overflow: hidden;
  /* position: absolute;
	top: 9.95rem;
	left: 3%; */
}

.router-pc .menuslist {
  padding: 0 20px 30px 20px;
}

.router-pc .menuslist li {
  width: 109px;
  margin-top: 30px;
}

.menuslist li {
  float: left;
  width: 1.2rem;
  margin-left: 0.15rem;
  margin-top: 0.2rem;
}

.menuslist li:nth-of-type(5n + 1) {
  margin-left: 0;
}

.menuslist li dl {
  text-align: center;
}

.menuslist li dl dt img {
  width: 75%;
}

.menuslist li dl dd {
  text-align: center;
  font-size: 0.22rem;
}

.index .banner {
  width: 94%;
  height: auto;
  margin: 0.2rem auto;
  border-radius: 5px;
}

.index .banner img {
  width: 100%;
  height: auto;
}

.productlist {
  /* margin: 0 auto; */
  /* width: 90%; */
  overflow: hidden;
  padding: 0 0.2rem;
}

.productlist li {
  width: 100%;
}

.productlist li img {
  display: block;
  width: 100%;
}

.productlist li dl dt img {
  width: 100%;
}

.product_name {
  width: 100%;
  height: 40px;
  overflow: hidden;
}

.product_price {
  display: inline-block;
  color: #ff2723;
  font-size: 0.36rem;
  font-weight: bold;
}

.otprice {
  color: #737373;
  text-decoration: line-through;
  margin-left: 0.1rem;
}

.ad {
  display: block;
  width: 94%;
  margin: 0.2rem auto;
}

.zhuantiTop {
  width: 94%;
  margin: 0.2rem auto;
  margin-bottom: 0;
}

.zhuantiTop img,
.ad img {
  display: block;
  width: 100%;
}

/* .index_footer {
  margin-top: 0.2rem;
  margin-bottom: 12%;
}

.index_footer img {
  width: 100%;
} */

#mask {
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.5);
}

.mask_close {
  /* position: absolute;
  bottom: 15%;
  left: 0;
  right: 0; */
  width: 0.7rem;
  display: block;
  margin: .2rem auto;
}

.zhuanti {
  /* height: 110px; */
  /* float: left; */
  /* width: 48%; */
  /* width: 100%; */
  height: 100%;
  background-color: #FF4E00;
  /* background-color: #25B75B; */
  /* padding: 0 10px; */
}

.zhuantiT {
  padding: 0px .2rem 8px;
  /* margin-top: 10px; */
  /* height: 117px; */
}
.zhuanti:first-child .zhuantiT {
  padding: 0px 10px ;
  /* margin-top: 10px; */
  /* height: 117px; */
}
.zhuantiT img {
  width: 100%;
}

.zhuantiContent {
  padding: 0 0.2rem;
}

.zhuantiImg {
  width: 100%;
  height: 180px;
  background-color: #fff;
  /* margin-bottom: 10px; */
}

.zhuantiImg img {
  width: 100%;
}

.zhuantiImg2 {
  float: left;
  margin-left: .2rem;
  margin-bottom: 10px;
  width: 46%;
  /* background-color: #fff6e1; */
}

.zhuantiImg2 img {
  width: 100%;
}
.zhuantiItem {
  width: 48%;
  /* height: 180px; */
  background-color: #fff;
  /* margin-bottom: 10px; */
}

.zhuantiItem img {
  width: 100%;
}

#mask {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.5);
}
.mask_img {
  /* width: 90%; */
  width: 75%;
  display: block;
  margin-top: -5%;
  /* margin-bottom: 5%; */
}


.box {
  float: left;
  background-color: #FF4E00;
  height: 100%;
}

/* 页面变灰 */
/* #index{
  filter: grayscale(1);
} */
.index_footer {
  float: left;
  background-color: #fff;
  margin-bottom: 12%;
  text-align: center;
}
.index_footer img {
  width: 100%;
}
.footer_zheng {
  width: 53% !important;
  margin-bottom: 0.4rem;
}
.footer_baozhang {
  position: relative;
  /* top: -0.6rem; */
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  padding: 0.3rem;
  margin: -0.6rem 0.2rem 0;
  font-size: 0.24rem;
  box-shadow: 0px 4px 16px 0px rgba(29, 29, 29, 0.1);
  border-radius: 0.12rem;
  z-index: 11;
}
.footer_baozhang img {
  width: 0.36rem;
  margin-right: 0.14rem;
}
.img_zpbz {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50%;
}
.footer_banquan {
  font-size: 0.18rem;
  color: #000000;
  /* scale: 0.9; */
  margin: 0.3rem 0;
}

.footer_banquan p ,.footer_xuke p{
  line-height: 0.3rem;
}
.footer_xuke{
  display: inline-block;
  font-size: 0.18rem;
  color: #000000;
  margin-bottom: 0.4rem;
}
@media screen and (min-width: 960px) {
  .search {
    margin: 0.45rem auto 0.1rem auto;
    font-size: 0.13rem;
    height: 0.26rem;
    line-height: 0.26rem;
  }
  .iconfont {
    font-size: 0.18rem;
  }
  .sousuo {
    width: 0.32rem;
  }
  .menuslist li {
    width: 0.6rem;
    margin-left: 0.07rem;
    margin-top: 0.1rem;
  }
  .menuslist li dl dd {
    font-size: 0.11rem;
    height: 0.18rem;
  }
  .menuslist {
    padding: 0 0.1rem 0.15rem 0.1rem;
    margin-top: 0.1rem;
  }
  .index .banner {
    margin: 0.1rem auto;
  }
  .zhuantiTop {
    margin-top: 0;
  }
  .zhuantiImg2 {
    margin-left: 0.1rem;
  }
  .footer_baozhang{
    font-size: .12rem;
    padding: .2rem;
    margin: -0.4rem 0.2rem 0;
  }
  .footer_baozhang img{
    width: .2rem;
  }
  .footer_banquan{
    font-size: .12rem;
    margin: .1rem 0;
  }
  .footer_banquan p ,.footer_xuke p{
    line-height: 0.2rem;
  }
  .footer_xuke{
    font-size: .12rem;
    margin-bottom: .2rem;
  }
}
@media only screen and (device-width: 432px) and (device-height: 768px) {
	/* .mask_img{
		width: 90%;
    display: block;
    margin: 10% auto;
	} */
}
</style>